// Basic
import React from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useCustomPayStore from '@/app/store/customPay';
// Components
import DetailsGrid from '@/common-utils/components/renders/detailsGrid/DetailsGrid';
import CustomPayConnectionPointsPanel from './CustomPayConnectionPointsPanel';
import { Separator } from '@/common-utils/components/ui/separator';
// Common
import organizationFields from '../../fields/organizationFields';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';

/**
 * @param root0
 * @param root0.connectionPoints
 * @param root0.organization
 * @returns {JSX} ConnectionPointsPanel
 */
function ConnectionPointsPanel({ connectionPoints, organization }) {

    // Constants
    const filteredConnectionPoints = connectionPoints.filter(connectionPoint => connectionPoint.port >= 30000 || connectionPoint.port === 1156);

    const connectionPointsDataToDisplay = {
        ipAddress: organizationFields.CONNECTION_POINTS.IP_ADDRESS,
        port: organizationFields.CONNECTION_POINTS.PORT
    };

    // Store
    const { isCustomPay } = useCustomPayStore();

    return (
        <div>
            {
                isCustomPay ?
                    <CustomPayConnectionPointsPanel
                        organization={organization}
                        organizationConnectionPointsFields={connectionPointsDataToDisplay}
                        filteredConnectionPoints={filteredConnectionPoints}
                    />
                    : filteredConnectionPoints.map((connectionPoint, index) => {
                        const connectionPointsData = {
                            [generateNestedFieldAccessor(organizationFields.CONNECTION_POINTS.IP_ADDRESS)]: connectionPoint.ipAddress,
                            [generateNestedFieldAccessor(organizationFields.CONNECTION_POINTS.PORT)]: connectionPoint.port
                        };
                        return (
                            <React.Fragment key={connectionPoint.uuid}>
                                <DetailsGrid data={connectionPointsData} fields={connectionPointsDataToDisplay} />
                                {
                                    index < filteredConnectionPoints.length - 1 &&
                                    <Separator className='my-4' />
                                }
                            </React.Fragment>
                        );
                    })

            }
        </div>
    );
}

ConnectionPointsPanel.propTypes = {
    connectionPoints: PropTypes.array.isRequired,
    organization: PropTypes.object.isRequired
};

export default ConnectionPointsPanel;